import React, {useState, useEffect} from 'react';
import _ from 'lodash';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import DynamicTable from 'componentLibrary/layout/dynamicTable';
import Accordion from 'app-ui-componentlibrary/dist/go/components/common/accordion/Accordion';
import {Pagination} from 'semantic-ui-react';
import REST from 'go/requests/rest';


export const DynamicTableAccordion = (props) => {
    const [sections, setSections] = useState([]);
    const [activeSectionId, setActiveSectionId] = useState(null);
    const [activePage, setActivePage] = useState(null);

    useEffect(() => {
        generateSections();
    }, []);

    useEffect(() => {
        if (activeSectionId != null) {
            const { data, sectionNameKey, sectionTotalCtKey } = props;
            const fetchData = async () => {
                const tableData = await getApiData(activePage, activeSectionId);
                const newSection = createSectionObject(
                    activeSectionId, 
                    data[activeSectionId][sectionNameKey],
                    activePage,
                    getPageCount(data[activeSectionId][sectionTotalCtKey]),
                    handlePageChange,
                    tableData
                );
                const mappedSections = _.map(sections, (section) => {
                    if (section.id == activeSectionId) {
                        return newSection;
                    }
                    else {
                        return section;
                    }
                });
                setSections(mappedSections);
            }
            fetchData();
        }
    }, [activePage])

    const createSectionObject = (id, name, activePage, pageCount, pageChangeHandler, tableData = []) => {
        return {
            id: id,
            name: name,
            content: (
                <span>
                    <DynamicTable
                        basic="very"
                        tableHeaders={props.tableHeaders}
                        contents={tableData}
                    >
                    </DynamicTable>
                    <Pagination
                        activePage={activePage}
                        onPageChange={pageChangeHandler}
                        siblingRange={2}
                        ellipsisItem={null}
                        totalPages={pageCount}
                        firstItem={null}
                        lastItem={null}
                    >
                    </Pagination>
                </span>
            )
        }
    }

    const getPageCount = (total) => {
        const offset = props.offset ? props.offset : 10;
        return _.ceil(total / offset);
    }

    const getApiData = async (pageNumber, activeSectionId) => {
        const {service, action, externalProps, dataKeys, apiDataKeys, offset, data} = props;
        let apiProps = {
            pageNumber,
            offset: offset || 10
        };
        _.forEach(externalProps, (val) => {
            apiProps[val] = props[val];
        })
        _.forEach(dataKeys, (val) => {
            apiProps[val] = data[activeSectionId][val];
        })
        return await REST[service][action](apiProps)
        .then((res) => res.json())
        .then((res) => {
            if (apiDataKeys) {
                let newRes = _.map(res, (row) => {
                    let newObj = {};
                    _.forEach(apiDataKeys, (val, idx) => {
                        newObj[idx] = row[val];
                    })
                    return newObj;
                });
                return generateTableContents(newRes);
            }
            else {
                return generateTableContents(res);
            }
        })
    }

    const generateTableContents = (dataArray) => {
        const contents = _.map(dataArray, (row, idx) => {
            let rowArray = Object.values(row);
            let rowContent = {
                id: idx,
                type: 'DynamicRow',
                fixedRow: rowArray
            };
            return rowContent;
        })
        return contents;
    };

    const generateSections = async () => {
        const {data, sectionNameKey, sectionTotalCtKey} = props;
        if (data) {
            let activeSectionId = 0;
            let initialSectionContents = await getApiData(1, activeSectionId);
            const initialSection = createSectionObject(
                activeSectionId,
                data[activeSectionId][sectionNameKey],
                1,
                getPageCount(data[activeSectionId][sectionTotalCtKey]),
                handlePageChange,
                initialSectionContents
            );

            let actualSections = _.reduce(data, (result, section, idx) => {
                if (activeSectionId != idx && idx != 'loading') {
                    const singleSection = createSectionObject(
                        idx,
                        section[sectionNameKey],
                        getPageCount(section[sectionTotalCtKey]),
                        handlePageChange
                    );
                    result.push(singleSection);
                }
                return result;
            }, []);
            const allSections = [initialSection, ...actualSections];
            setSections(allSections);
            setActiveSectionId(0);
        }
    };

    const handlePageChange = (e, data) => {
        const { activePage } = data;
        setActivePage(activePage);
    };

    const handleExpand = async (e, {name}) => {
        setActiveSectionId(activeSectionId === name ? '' : name);
        const { data, sectionNameKey, sectionTotalCtKey } = props;

        if (activeSectionId != name) {
            setActivePage(1);
            const tableData = await getApiData(1, name);
            const newSection = createSectionObject(
                name, 
                data[name][sectionNameKey],
                1,
                getPageCount(data[name][sectionTotalCtKey]),
                handlePageChange,
                tableData
            );
            const mappedSections = _.map(sections, (section) => {
                if (section.id == name) {
                    return newSection;
                }
                else {
                    return section;
                }
            });
            setSections(mappedSections);
        }
    };

    return (
        <React.Fragment>
            <div className="dynamic-Accordion-wrapper textSmall">
                <div id="accordion">
                <Accordion
                    sections={sections}
                    activeSection={activeSectionId}
                    handleExpand={handleExpand}
                />
                </div>
            </div>
        </React.Fragment>
    )
}
  
export default connectDynamic(DynamicTableAccordion);